// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.container[data-v-5fc7a41a]{\r\n\tbackground-size: contain;\r\n\tbackground-repeat: no-repeat;\r\n\tpointer-events: all;\n}\n.logo[data-v-5fc7a41a]{\r\n\twidth:auto;\r\n\theight:auto;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
